import { render, staticRenderFns } from "./vue-qz-tray-action.vue?vue&type=template&id=7a6e5545&scoped=true&"
import script from "./vue-qz-tray-action.vue?vue&type=script&lang=js&"
export * from "./vue-qz-tray-action.vue?vue&type=script&lang=js&"
import style0 from "./vue-qz-tray-action.vue?vue&type=style&index=0&id=7a6e5545&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6e5545",
  null
  
)

export default component.exports